import { Grid, Section } from '@gogame/components';
import React from 'react';

const GeneralSection = ({ payToLocked, onLockPayTo, filters = {} }) => (
  <Section paddingTop={0}>
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <filters.RegistrationPeriod payToLocked={payToLocked} />
      </Grid>
      <Grid item xs={4}>
        <filters.PayTo locked={payToLocked} onLock={onLockPayTo} />
      </Grid>
      {filters.TrafficType ? (
        <Grid item xs={4}>
          <filters.TrafficType />
        </Grid>
      ) : null}
      <Grid item xs={4}>
        <filters.Applications />
      </Grid>
      <Grid item xs={4}>
        <filters.Networks withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.Clusters withFavoriteActions={true} />
      </Grid>
      {filters.BusinessPartners ? (
        <Grid item xs={4}>
          <filters.BusinessPartners
            dropdownWidth={'440px'}
            withFavoriteActions={true}
          />
        </Grid>
      ) : null}
      <Grid item xs={4}>
        <filters.Affiliates
          dropdownWidth={'440px'}
          withFavoriteActions={true}
        />
      </Grid>
      <Grid item xs={4}>
        <filters.Campaigns dropdownWidth={'440px'} withFavoriteActions={true} />
      </Grid>
      {filters.Managers ? (
        <Grid item xs={4}>
          <filters.Managers withFavoriteActions={true} />
        </Grid>
      ) : null}
      {filters.Owners ? (
        <Grid item xs={4}>
          <filters.Owners withFavoriteActions={true} />
        </Grid>
      ) : null}
      <Grid item xs={4}>
        <filters.Platforms withFavoriteActions={true} />
      </Grid>
      {filters.Genres ? (
        <Grid item xs={4}>
          <filters.Genres withFavoriteActions={true} />
        </Grid>
      ) : null}
      <Grid item xs={4}>
        <filters.Countries withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.RealCountries withFavoriteActions={true} />
      </Grid>

      {filters.ChannelTypes ? (
        <Grid item xs={4}>
          <filters.ChannelTypes withFavoriteActions={true} />
        </Grid>
      ) : null}
      {filters.Channels ? (
        <Grid item xs={4}>
          <filters.Channels withFavoriteActions={true} />
        </Grid>
      ) : null}
      {filters.Labels ? (
        <Grid item xs={4}>
          <filters.Labels withFavoriteActions={true} />
        </Grid>
      ) : null}
      {filters.Clients ? (
        <Grid item xs={4}>
          <filters.Clients withFavoriteActions={true} />
        </Grid>
      ) : null}
      {filters.DeviceType ? (
        <Grid item xs={4}>
          <filters.DeviceType withFavoriteActions={true} />
        </Grid>
      ) : null}
      <Grid item xs={4}>
        <filters.CPFlow withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.Registrations withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.CampaignType withFavoriteActions={true} />
      </Grid>
      {filters.Statuses ? (
        <Grid item xs={4}>
          <filters.Statuses withFavoriteActions={true} />
        </Grid>
      ) : null}
      <Grid item xs={4}>
        <filters.FraudType withFavoriteActions={true} />
      </Grid>
      {filters.RECounter ? (
        <Grid item xs={4}>
          <filters.RECounter withFavoriteActions={true} />
        </Grid>
      ) : null}
      {filters.CPELiveEvents ? (
        <Grid item xs={4}>
          <filters.CPELiveEvents withFavoriteActions={true} />
        </Grid>
      ) : null}
      {filters.CPELiveEventType ? (
        <Grid item xs={4}>
          <filters.CPELiveEventType withFavoriteActions={true} />
        </Grid>
      ) : null}
    </Grid>
  </Section>
);
export default GeneralSection;
